const FiltersForQueryParams = (filters) => {
  if (!filters) {
    return void 0;
  }
  return filters.entrySeq().flatMap(([attributeId, filterValues]) => filterValues.map((value) => `${attributeId}:${value}`)).toArray();
};
export default FiltersForQueryParams;
